import './TransparentButton.css';
const TransparentButton = ({
   type = 'button',
   onClick,
   children,
   bg,
   color,
   disabled,
   className,
   opacity,
   dataDissmiss,
   propstyle,
   width,
   fontSize,
   ...rest
}) => {
   const style = {
      border: bg ? 'none' : '2px solid #2B3A67',
      color: color ? color : '#2B3A67',
      backgroundColor: bg ? bg : 'transparent',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: opacity ? opacity : 1,
    width:width,
  fontSize:fontSize,
      ...propstyle
   };
   return (
      <button
         type={type}
         onClick={onClick}
         {...rest}
         className={
            className ? `transparent-style ${className}` : `transparent-style`
         }
         style={style}
         disabled={disabled ? true : ''}
         data-dismiss={dataDissmiss ? dataDissmiss : ''}
      >
         {children}
      </button>
   );
};

export default TransparentButton;
